import { useState } from "react";
// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import { styled } from "@mui/system";
import EditNoteIcon from "@mui/icons-material/EditNote";

// InterFace
import { EditDataDifine } from "../../config/dataInterface";
import { LIST_POST } from "../../config/const";
import { PO_MODAL_SX, PO_MODAL_SX_SP } from "../../lib/poModalFrame";
import { PoButton } from "../common/PoButton";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";
// ★cmd-po_1221 R9: 編集成功をトースト→結果モーダルへ統一
import { DataAddModalResult } from "../DataAddModalResult";

interface SystemConfigEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editSystemConfig: {
    status: "before" | "editing" | "success" | "failed" | string;
    key: string;
    value: string;
    name: string;
  } | null;
  setEditSystemConfig: (
    data: {
      status: "before" | "editing" | "success" | "failed" | string;
      key: string;
      value: string;
      name: string;
    } | null
  ) => void;
  putEditData: () => void;
}
const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};
export function SystemConfigEditModal(props: SystemConfigEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editSystemConfig,
    setEditSystemConfig,
    putEditData,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);

  // ★cmd-po_1221 R9: 成功トースト+自動クローズ処理を廃止＝結果モーダル統一。

  const style = isSmartPhone ? PO_MODAL_SX_SP : PO_MODAL_SX;
  return editSystemConfig ? (
    <>
    <Modal
      open={onModal && editSystemConfig?.status !== "success"}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="system-config-edit-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
        >
          編集 - {editSystemConfig.name}
        </Box>
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            mb: 5,
            maxHeight: isSmartPhone ? "calc(92vh - 30px)" : undefined,
            overflowY: isSmartPhone ? "auto" : undefined,
          }}
        >
          <Paper elevation={0}>
            {editSystemConfig.status === "before" ? (
              <>
                <Box key="old-pass">
                  <Box sx={{ fontSize: "var(--fs-12, 12px)", fontWeight: 600, color: "var(--color-sumi, #374151)", marginBottom: "2px" }}>変更後</Box>
                  <CustomTextField
                    id="textFieldId"
                    value={editSystemConfig.value}
                    size="small"
                    onChange={(e) =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        value: e.target.value,
                      })
                    }
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                  />
                  {editSystemConfig.key == "password_master_account" ||
                  editSystemConfig.key == "password_staff_account" ? (
                    <FormHelperText
                      id="serch-name"
                      sx={{
                        width: "calc(100% - 10px)",
                        textAlign: "right",
                        marginTop: "-8px",
                        marginRight: "5px",
                        height: "25px",
                      }}
                    >
                      ※既存の
                      {editSystemConfig.key == "password_master_account"
                        ? "マスター"
                        : "スタッフ"}
                      アカウントの初期パスワードは変更されません。
                    </FormHelperText>
                  ) : null}
                </Box>
                <Box
                  data-testid="system-config-edit-footer"
                  sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--sp-3)", py: "var(--sp-3)", px: "var(--sp-5)", borderTop: "1px solid var(--color-border-light, #efefea)", flexShrink: 0 }}
                >
                  <PoButton
                    data-testid="system-config-edit-cancel"
                    variant="secondary"
                    onClick={swCloseModal}
                  >
                    キャンセル
                  </PoButton>
                  <PoButton
                    data-testid="system-config-edit-submit"
                    variant="primary"
                    disabled={editSystemConfig.value === ""}
                    onClick={putEditData}
                  >
                    編集
                    <EditNoteIcon fontSize="medium" />
                  </PoButton>
                </Box>
              </>
            ) : editSystemConfig.status === "failed" ? (
              <>
                <Box>
                  編集に失敗しました。
                  <br />
                  データの形式が異なる可能性があります。
                </Box>
                <Box>
                  <Button
                    data-testid="system-config-edit-failed-back"
                    style={{
                      marginTop: "30px",
                      marginLeft: !isSmartPhone ? "15%" : "5px",
                      height: "40px",
                      width: !isSmartPhone ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box>OK</Box>
                  </Button>
                </Box>
              </>
            ) : editSystemConfig.status === "NotPasswordPolicy" ? (
              <>
                <Box>
                  パスワードの要件を満たしていません。
                  <br />
                  大文字・小文字・数字・記号を含む
                  <br />
                  8文字以上の文字列をご入力ください。
                </Box>
                <Box>
                  <Button
                    data-testid="system-config-edit-password-back"
                    style={{
                      marginTop: "30px",
                      marginLeft: !isSmartPhone ? "15%" : "5px",
                      height: "40px",
                      width: !isSmartPhone ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box>OK</Box>
                  </Button>
                </Box>
              </>
            ) : editSystemConfig.status === "success" ? null : (
              <>
                <Box>
                  {editSystemConfig.status}
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: !isSmartPhone ? "15%" : "5px",
                      height: "40px",
                      width: !isSmartPhone ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box>OK</Box>
                  </Button>
                </Box>
              </>
            )}
          </Paper>
        </Typography>
      </Box>
    </Modal>
    {/* ★cmd-po_1221 R9: 編集成功=結果モーダル（トースト→統一・閉じるで手動クローズ） */}
    <DataAddModalResult
      onModal={onModal && editSystemConfig?.status === "success"}
      onDataAddModalResult="success"
      successMessage="変更を保存しました。"
      swCloseModal={swCloseModal}
      addModalTitle="編集"
    />
    </>
  ) : null;
}
